import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Subject } from 'rxjs';

import { trackByProp } from '@recruitee/common';
import { TranslatePipe } from '@recruitee/i18n';
import type { RequisitionOpening } from '@recruitee/requisitions-types';
import { EmptyStateComponent, HeadingComponent } from '@recruitee/user-interface';

import { RequisitionsHiredCandidateCardComponent } from '../../../components/requisitions-hired-candidate-card/requisitions-hired-candidate-card.component';
import { HiresFacade } from '../../../facades/single-requisition/hires.facade';
import { SingleRequisitionsActionsService } from '../../../services/single-requisitions-actions.service';

@Component({
  standalone: true,
  selector: 'rt-requisitions-hires-container',
  templateUrl: './requisitions-hires-container.component.html',
  styleUrls: ['./requisitions-hires-container.component.less'],
  imports: [
    EmptyStateComponent,
    HeadingComponent,
    RequisitionsHiredCandidateCardComponent,
    RouterModule,
    TranslatePipe,
  ],
})
export class RequisitionsHiresContainerComponent {
  @Input() public hires: RequisitionOpening[];
  @Input() public requisitionId: number;

  public canViewCandidateProfile: boolean;
  public canUnassignCandidates: boolean;

  public trackById = trackByProp<{ id: string | number }>({ prop: 'id' });

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private hiresFacade: HiresFacade,
    private requisitionsActionsService: SingleRequisitionsActionsService,
  ) {}

  public ngOnInit(): void {
    this.canViewCandidateProfile = this.hiresFacade.canViewCandidateProfile;
    this.canUnassignCandidates = this.hiresFacade.canUnassignCandidates;
  }

  public unassignCandidate(openingId: number) {
    this.requisitionsActionsService.unassignCandidate(openingId, this.requisitionId);
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
